import { render, staticRenderFns } from "./Resizable.vue?vue&type=template&id=cb8fe668&scoped=true"
import script from "./Resizable.vue?vue&type=script&lang=ts"
export * from "./Resizable.vue?vue&type=script&lang=ts"
import style0 from "./Resizable.vue?vue&type=style&index=0&id=cb8fe668&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8fe668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb8fe668')) {
      api.createRecord('cb8fe668', component.options)
    } else {
      api.reload('cb8fe668', component.options)
    }
    module.hot.accept("./Resizable.vue?vue&type=template&id=cb8fe668&scoped=true", function () {
      api.rerender('cb8fe668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/Resizable.vue"
export default component.exports